<script>
    import R, {LOADER} from "../../lib/requests";
    import {clickOutside} from '../../lib/clickOutside.js';
    import {createEventDispatcher} from 'svelte/internal';
    import Icon from "../../components/Icon.svelte";
    import {setFocusTo} from "../../lib/lib";
    import ColorControl from "./ColorControl.svelte";
    import ColoredNameControl from "./ColoredNameControl.svelte";

    export let projectId = null;
    export let clientId = null; // select only projects from specified client
    export let project = null;
    export let id = 'searchProjectName';
    export let excludeFromSelection = []; // project objects to exclude from selection
    export let sm = false;
    export let placeholder = "εύρεση project";
    export let disabled = false;

    let name = project ? project.name : '';
    let results = [];
    let listIndex = -1;
    let excludeIds = [];
    let timer;
    let showDropdown = false;

    const dispatch = createEventDispatcher();

    const handleEscapeKey = event => {
        if (event.key === 'Escape') {
            closeDropdown();
        }
    }

    const onKeydown = (event) => {
        if (results && results.length) {
            if (event.key === 'ArrowDown') {
                event.preventDefault();
                listIndex++;
                if (listIndex >= results.length) {
                    listIndex = 0;
                }
            } else if (event.key === 'ArrowUp') {
                event.preventDefault();
                listIndex--;
                if (listIndex < 0) {
                    listIndex = results.length - 1;
                }
            } else if (event.key === 'Enter' && listIndex > -1) {
                event.preventDefault();
                selectResult(results[listIndex]);
            } else if (event.key === 'Escape') {
                closeDropdown();
            }
        }
    }

    const onKeyup = (event) => {
        // if (name !== event.target.value && event.target.value.length) {
        if (name !== event.target.value) {
            name = event.target.value;
            if (timer) {
                clearInterval(timer);
            }
            timer = setInterval(() => {
                clearInterval(timer);
                load();
            }, 500);

            if (!name) {
                projectId = 0;
                project = null;
            }
        }
    }

    const onFocusIn = () => {
        if (!project) {
            load();
        }
        dispatch('focusin');
    }

    const onFocusOut = () => {
        if (project === null) {
            name = '';
        }
        dispatch('focusout');
    }

    const selectResult = (item) => {
        name = item.name;
        projectId = item.id;
        project = item;
        dispatch('change', item);
        closeDropdown();
    }

    const load = () => {
        const onSuccess = result => {
            results = [];
            result.map(item => {
                if (excludeIds.indexOf(item.id) < 0) {
                    results.push(item);
                }
            });
            openDropdown();
        }

        const onFailure = err => {
        };

        R.handle(R.project.index, {name: name, client_id: clientId}, onSuccess, onFailure);
    }

    const openDropdown = () => {
        if (!showDropdown) {
            showDropdown = true;
            document.addEventListener('keydown', handleEscapeKey);
        }
    }

    const closeDropdown = () => {
        if (showDropdown) {
            showDropdown = false;
            results = [];
            listIndex = -1;
            document.removeEventListener('keydown', handleEscapeKey);
        }
    }

    if (project && !projectId) {
        projectId = project.id;
    }

    $: {
        if (excludeFromSelection) {
            if (excludeFromSelection.length != excludeIds.length) {
                excludeIds = excludeFromSelection.map(item => {
                    return item.id;
                });
            }
        } else {
            excludeIds = [];
        }

        if (!projectId && project) {
            project = null;
            name = '';
        }
    }
</script>

<div class="select-control" use:clickOutside on:click_outside="{ closeDropdown }">
    <div class="search">
        <input type="text" class="form-control" class:form-control-sm={ sm } {id} value="{ name }"
               on:keydown="{ onKeydown }"
               on:keyup="{ onKeyup }"
               on:focusin={ onFocusIn }
               on:focusout={ onFocusOut }
               autocomplete="off"
               {placeholder} {disabled}>
    </div>
    {#if showDropdown}
        <div class="control-dropdown">
            <ul>
                {#if results.length}
                    {#each results as item, index}
                        <li class="dropdown-item" class:active="{ listIndex === index }"
                            on:click="{ () => selectResult(item) }">
                            <ColoredNameControl name="{ item.name }" color="{ item.color }" colorName/>
                        </li>
                    {/each}
                {/if}
            </ul>
        </div>
    {/if}
</div>

<style>
    .select-control {
        position: relative;
    }

    .select-control .control-dropdown {
        position: absolute;
        width: max-content;
        min-width: 200px;
        background: var(--dropdown-background);
        box-shadow: var(--dropdown-box-shadow);
        z-index: 5000;
    }

    .control-dropdown ul {
        list-style: none;
        padding: 0;
        margin: 0;
    }

    .control-dropdown ul > li.input-item {
        padding: 15px;
    }

    .control-dropdown ul > li.dropdown-item {
        cursor: pointer;
        padding: 10px 10px;
    }

    .control-dropdown ul > li.dropdown-item:hover,
    .control-dropdown ul > li.dropdown-item.active {
        background: var(--dropdown-item-hover-background);
    }

    /*.control-dropdown ul > li.dropdown-button {*/
    /*    text-align: center;*/
    /*    background: var(--dropdown-button-background);*/
    /*    cursor: pointer;*/
    /*    padding: 10px 20px;*/
    /*}*/

    .control-dropdown ul > li.separator {
        border-top: var(--dropdown-separator);
    }
</style>